<template>
  <a-form-item
    :label="isLabel===false||widget.type==='divider' || !widget.options.labelWidthStatus?'':widget.name"
    :label-width="isLabel===false||!widget.options.labelWidthStatus?'0px': widgetLabelWidth + 'px'"
    :prop="propValue"
    :style="subformIndex !== undefined?{'margin-bottom': '0'}: {}"
    v-if="showStatus"
  >
    <template v-if="preview">
      <template v-if="widget.type === 'color'">
        <div
          :style="{'background-color': dataModel}"
          style="width: 32px; height: 20px; margin-top: 6px; border-radius: 3px"
        />
      </template>
      <template v-else-if="widget.type=='switch'">
        <a-switch :disabled="true" v-model="dataModel" />
      </template>
      <template v-else-if="widget.type === 'editor'">
        <div class="previewEditorDiv" v-html="dataModel" />
      </template>

      <template v-else-if="widget.type=='file'">
        <div :key="uploadUrlIndex" v-for="(uploadUrlItem, uploadUrlIndex) of dataModel">
          <i class="el-icon-document" style="color: #909399;" />
          <a :href="uploadUrlItem.url" target="_blank">{{ uploadUrlItem.name }}</a>
        </div>
      </template>

      <template v-else-if="widget.type=='imgupload'">
        <fm-upload
          :height="widget.options.size.height"
          :preview="preview"
          :style="{'width': widget.options.width}"
          :width="widget.options.size.width"
          v-model="dataModel"
        />
      </template>
      <template v-else-if="widget.type =='rate'">
        <a-rate :allow-half="widget.options.allowHalf" :disabled="true" :max="widget.options.max" v-model="dataModel" />
      </template>
      <template v-else-if="widget.type === 'divider'">
        <a-divider :content-position="widget.options.content_position" :direction="widget.options.direction">
          <span
            :style="{
              'font-size': widget.options.font_size,
              'font-family': widget.options.font_family,
              'font-weight': widget.options.font_weight,
              'color': widget.options.font_color
            }"
          >{{ widget.options.defaultValue }}</span>
        </a-divider>
      </template>
      <template v-else-if="widget.type === 'input' && widget.options.showPassword">
        <input
          :value="dataModel"
          disabled="disabled"
          style="border: none; background-color: #ffffff; color: #303133"
          type="password"
        />
      </template>
      <template v-else-if="widget.type === 'cascader'">
        <a-cascader
          :disabled="true"
          :options="widget.options.remote?widget.options.remoteOptions:widget.options.options"
          :show-all-levels="widget.options.showAllLevels"
          class="preview-cascader-class"
          v-model="dataModel"
        />
      </template>
      <template v-else>
        <div>{{ dataModel }}</div>
      </template>
    </template>
    <template v-else>
      <template v-if="widget.type === 'input'">
        <a-input
          :disabled="widget.options.disabled"
          :placeholder="widget.options.placeholder"
          :show-password="widget.options.showPassword"
          :style="{width: widget.options.width}"
          :type="widget.options.dataType"
          v-if="widget.options.dataType === 'number'
            || widget.options.dataType === 'integer'
            || widget.options.dataType === 'float'"
          v-model.number="dataModel"
        />
        <a-input
          :disabled="widget.options.disabled"
          :placeholder="widget.options.placeholder"
          :show-password="widget.options.showPassword"
          :style="{width: widget.options.width}"
          :type="widget.options.dataType"
          v-else
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type === 'textarea'">
        <a-input
          :disabled="widget.options.disabled"
          :placeholder="widget.options.placeholder"
          :rows="5"
          :style="{width: widget.options.width}"
          type="textarea"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type === 'number'">
        <a-input-number
          :disabled="widget.options.disabled"
          :step="widget.options.step"
          :style="{width: widget.options.width}"
          controls-position="right"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type === 'radio'">
        <a-radio-group :disabled="widget.options.disabled" :style="{width: widget.options.width}" v-model="dataModel">
          <a-radio
            :key="index"
            :label="item.value"
            :style="{display: widget.options.inline ? 'inline-block' : 'block'}"
            :value="item.value"
            v-for="(item, index) in (widget.options.remote ? widget.options.remoteOptions : widget.options.options)"
          >
            <template v-if="widget.options.remote">{{ item.label }}</template>
            <template v-else>{{ widget.options.showLabel ? item.label : item.value }}</template>
          </a-radio>
        </a-radio-group>
      </template>

      <template v-if="widget.type === 'checkbox'">
        <a-checkbox-group
          :disabled="widget.options.disabled"
          :style="{width: widget.options.width}"
          v-model="dataModel"
        >
          <a-checkbox
            :key="index"
            :label="item.value"
            :style="{display: widget.options.inline ? 'inline-block' : 'block'}"
            v-for="(item, index) in (widget.options.remote ? widget.options.remoteOptions : widget.options.options)"
          >
            <template v-if="widget.options.remote">{{ item.label }}</template>
            <template v-else>{{ widget.options.showLabel ? item.label : item.value }}</template>
          </a-checkbox>
        </a-checkbox-group>
      </template>

      <template v-if="widget.type === 'time'">
        <a-time-picker
          :clearable="widget.options.clearable"
          :defaultValue="widget.options.defaultValue"
          :disabled="widget.options.disabled"
          :editable="widget.options.editable"
          :end-placeholder="widget.options.endPlaceholder"
          :is-range="widget.options.isRange"
          :placeholder="widget.options.placeholder"
          :readonly="widget.options.readonly"
          :start-placeholder="widget.options.startPlaceholder"
          :style="{width: widget.options.width}"
          :valueFormat="widget.options.format"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type=='date'">
        <a-date-picker
          :clearable="widget.options.clearable"
          :defaultValue="widget.options.defaultValue"
          :disabled="widget.options.disabled"
          :editable="widget.options.editable"
          :end-placeholder="widget.options.endPlaceholder"
          :format="widget.options.format"
          :placeholder="widget.options.placeholder"
          :readonly="widget.options.readonly"
          :start-placeholder="widget.options.startPlaceholder"
          :style="{width: widget.options.width}"
          :type="widget.options.type"
          :valueFormat="widget.options.timestamp ? 'timestamp' : widget.options.format"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type =='rate'">
        <a-rate
          :allow-half="widget.options.allowHalf"
          :disabled="widget.options.disabled"
          :max="widget.options.max"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type === 'color'">
        <a-color-picker :disabled="widget.options.disabled" :show-alpha="widget.options.showAlpha" v-model="dataModel" />
      </template>

      <template v-if="widget.type === 'select'">
        <a-select
          :allowClear="widget.options.clearable"
          :disabled="widget.options.disabled"
          :filterOption="widget.options.filterable"
          :mode="widget.options.multiple == true ? multiple : '-'"
          :placeholder="widget.options.placeholder"
          :style="{width: widget.options.width}"
          v-model="dataModel"
        >
          <a-select-option
            :key="item.value"
            :value="item.value"
            v-for="item in (widget.options.remote ? widget.options.remoteOptions : widget.options.options)"
          >{{widget.options.showLabel || widget.options.remote?item.label:item.value}}</a-select-option>
        </a-select>
      </template>

      <template v-if="widget.type=='switch'">
        <a-switch :disabled="widget.options.disabled" v-model="dataModel" />
      </template>

      <template v-if="widget.type=='slider'">
        <a-slider
          :disabled="widget.options.disabled"
          :max="widget.options.max"
          :min="widget.options.min"
          :range="widget.options.range"
          :show-input="widget.options.showInput"
          :step="widget.options.step"
          :style="{width: widget.options.width}"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type=='imgupload'">
        <fm-upload
          :action="widget.options.action"
          :disabled="widget.options.disabled"
          :domain="widget.options.domain"
          :height="widget.options.size.height"
          :is-delete="widget.options.isDelete"
          :is-edit="widget.options.isEdit"
          :is-qiniu="widget.options.isQiniu"
          :length="widget.options.length"
          :min="widget.options.min"
          :multiple="widget.options.multiple"
          :style="{'width': widget.options.width}"
          :token="widget.options.token"
          :width="widget.options.size.width"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type=='file'">
        <FileUpload :data-model="dataModel" :element="widget" @fileList="fileList" />
      </template>

      <template v-if="widget.type === 'editor'">
        <vue-editor :disabled="widget.options.disabled" :style="{width: widget.options.width}" v-model="dataModel" />
      </template>

      <template v-if="widget.type === 'cascader'">
        <a-cascader
          :clearable="widget.options.clearable"
          :disabled="widget.options.disabled"
          :options="widget.options.remote?widget.options.remoteOptions:widget.options.options"
          :placeholder="widget.options.placeholder"
          :show-all-levels="widget.options.showAllLevels"
          :style="{width: widget.options.width}"
          v-model="dataModel"
        />
      </template>

      <template v-if="widget.type === 'text'">
        <span
          :style="{
            'font-size': widget.options.font_size,
            'font-family': widget.options.font_family,
            'font-weight': widget.options.font_weight,
            'color': widget.options.font_color
          }"
        >{{ widget.options.defaultValue }}</span>
      </template>

      <template v-if="widget.type === 'divider'">
        <a-divider :content-position="widget.options.content_position" :direction="widget.options.direction">
          <span
            :style="{
              'font-size': widget.options.font_size,
              'font-family': widget.options.font_family,
              'font-weight': widget.options.font_weight,
              'color': widget.options.font_color
            }"
          >{{ widget.options.defaultValue }}</span>
        </a-divider>
      </template>
    </template>
  </a-form-item>
</template>

<script>
  import FmUpload from './Upload'
  import FileUpload from './Upload/file'

  export default {
    name: 'GenetateFormItem',
    components: {
      FmUpload,
      FileUpload
    },
    /* eslint-disable */
    props: ['widget', 'models', 'propValue', 'remote', 'data', 'disabled', 'preview', 'isLabel', 'subformIndex', 'subformModel'],
    data () {
      return {
        showStatus: true,
        widgetLabelWidth: '',
        dataModel: this.subformIndex === undefined ?
          this.models[this.widget.model] :
          this.models[this.subformModel][this.subformIndex][this.widget.model],
        tableData: []
      }
    },
    watch: {
      dataModel: {
        deep: true,
        handler (newValue) {
          if (newValue !== undefined && newValue !== null) {
            if (this.subformIndex !== undefined) {
              this.models[this.subformModel][this.subformIndex][this.widget.model] = newValue
              this.$emit('update:models', {
                ...this.models,
                [this.subformModel]: this.models[this.subformModel]
              })
              // this.$emit('input-change', val, this.widget.model, this.subformIndex)
            } else {
              this.models[this.widget.model] = newValue
              this.$emit('update:models', {
                ...this.models,
                [this.widget.model]: newValue
              })
              // this.$emit('input-change', val, this.widget.model)
            }
          }
        }
      },
      models: {
        deep: true,
        handler (val) {
          if (val.status === undefined && val.status === null) {
            if (this.subformIndex === undefined) {
              this.dataModel = val[this.widget.model]
            } else {
              this.dataModel = val[this.subformModel][this.subformIndex][this.widget.model]
            }
          }
          delete this.models.status
          this.handleDisplayVerifiy()
        }
      }
    },
    created () {
      if (this.widget.options.remote && this.remote[this.widget.options.remoteFunc]) {
        this.remote[this.widget.options.remoteFunc]((data) => {
          this.widget.options.remoteOptions = data.map(item => {
            return {
              value: item[this.widget.options.props.value],
              label: item[this.widget.options.props.label],
              children: item[this.widget.options.props.children]
            }
          })
        })
      }

      if (this.widget.type === 'imgupload' && this.widget.options.isQiniu) {
        this.remote[this.widget.options.tokenFunc]((data) => {
          this.widget.options.token = data
        })
      }

      if (this.disabled !== undefined && this.disabled !== null) {
        this.widget.options.disabled = this.disabled
      }

      // label width
      if (this.widget.options.labelWidthDisabled) {
        this.widgetLabelWidth = this.widget.options.labelWidth
      } else if (this.widget.type === 'divider') {
        this.widgetLabelWidth = 0
      } else {
        this.widgetLabelWidth = this.data.config.labelWidth
      }

      this.handleDisplayVerifiy()
    },
    methods: {
      fileList (files) {
        this.dataModel = files
      },
      handleDisplayVerifiy () {
        if (Object.keys(this.widget.options).indexOf('displayVerifiy') >= 0) {
          if (this.widget.options.displayVerifiy.type !== 'hide') {
            var c = 0
            for (var v of this.widget.options.displayVerifiy.list) {
              if (this.models[v.model].toString() === v.value) {
                c++
              }
            }
            if (this.widget.options.displayVerifiy.type === 'and') {
              if (c !== this.widget.options.displayVerifiy.list.length) {
                this.showStatus = false
              } else {
                this.showStatus = true
              }
            } else if (this.widget.options.displayVerifiy.type === 'or') {
              if (c === 0) {
                this.showStatus = false
              } else {
                this.showStatus = true
              }
            }
          }
        }
      }
    }
  }
</script>

<style>

  .previewEditorDiv > p {
    margin: 0;
  }

  .preview-cascader-class .a-input.is-disabled .a-input__inner {
    background-color: #fff;
    border: none;
    color: #303133;
  }

  .preview-cascader-class
    .a-input.is-disabled
    .a-input__suffix
    .a-input__suffix-inner
    .a-input__icon.el-icon-arrow-down:before {
    content: '';
  }

</style>
